module.exports = __webpack_public_path__ + "img/disc.ffaee505.svg";